import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class PublicationService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;


  getAllActivePublications(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publication/all/active").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getAllPublications(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publication/all").subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }



  getPublicationList(pageNo: number, pageSize: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publication?pageNo=" + pageNo + "&pageSize=" + pageSize).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getAllPublicationById(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/publication/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  savePublication(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/publication", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  updatePublication(id: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.put(this.url + "management/publication/" + id, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


  getDownloadURL(): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "management/publication/download?token=" + authToken;
  }

  downloadPublications(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "management/publication/download").subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }


}